import { render, staticRenderFns } from "./default-group.vue?vue&type=template&id=360099eb&scoped=true"
import script from "./default-group.vue?vue&type=script&lang=js"
export * from "./default-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360099eb",
  null
  
)

export default component.exports